var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInsta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.057 3.385a4.571 4.571 0 014.558 4.558v9.114a4.572 4.572 0 01-4.558 4.558H7.943a4.571 4.571 0 01-4.558-4.558V7.943a4.571 4.571 0 014.558-4.558h9.114zm0-1.822H7.943c-3.51 0-6.38 2.87-6.38 6.38v9.114c0 3.51 2.87 6.38 6.38 6.38h9.114c3.51 0 6.38-2.87 6.38-6.38V7.943c0-3.51-2.87-6.38-6.38-6.38z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.424 7.943a1.367 1.367 0 110-2.735 1.367 1.367 0 010 2.735zm-5.924.911a3.646 3.646 0 110 7.292 3.646 3.646 0 010-7.292zm0-1.823a5.469 5.469 0 100 10.938 5.469 5.469 0 000-10.938z",
    fill: "#000"
  })));
}
export default SvgIconInsta;